import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./CommitmentsTabView.module.css";
import { CommitmentBox } from "..";
import type { Commitment } from "../commitment-box/CommitmentBox";
import { isNonEmptyArray } from "../../../../../../../../../common/utils";
import { CollabService } from "../../../../../../../../../api";
import { useApi } from "../../../../../../../../../common/hooks";

interface CommitmentsTabViewProps {
	readonly informationId: number;
}
const CommitmentsTabView = ({ informationId }: CommitmentsTabViewProps) => {
	const [commitments, setCommitments] = useState<Commitment[]>([]);
	const projectId = useSelector(({ context }) => context.project.id);
	const { call: getCommitmentsForInformation } = useApi(CollabService.getCommitmentsForInformation);
	useEffect(() => {
		if (projectId && informationId) {
			getCommitmentsForInformation({ projectId, infoId: informationId })
				.then((data: Commitment[]) => setCommitments(data))
				.catch(console.error);
		}
	}, [informationId, projectId, getCommitmentsForInformation]);

	return (
		<div className={styles.container}>
			{isNonEmptyArray(commitments) &&
				commitments.map((commitment) => (
					<CommitmentBox key={commitment.commitmentId} commitment={commitment} />
				))}
		</div>
	);
};

export default CommitmentsTabView;
